import React, { Fragment, useEffect, useRef } from 'react';
import {
  Button,
  ButtonGroup,
  Card,
  Dropdown,
  ProgressBar,
  Tab,
  Tabs,
} from 'react-bootstrap';
import { FaTimes, FaWindowMinimize } from 'react-icons/fa';
import { connect, useDispatch } from 'react-redux';

import icMagnifier from '../../../../assets/img/magnifier.png';

import Finance from './tabFinance';
import History from './tabHistory';
import OverView from './tabOvervew';
import Profile from './tabProfile';
import TransferData from './tabTransferData';

import BuocGia from './tabBuocGia';
import News from './tabNews';

// import { v4 as uuidv4 } from 'uuid';
import {
  addZero,
  colorFix,
  daysInMonth,
  formatDate,
  formatVolume10,
  numberFormat,
  StringToInt,
} from '../../../../utils';

import {
  associateRequest,
  cdktRequest,
  collectionPriceRequest,
  companyInfoRequest,
  cstRequest,
  kqkdRequest,
  newsDetailRequest,
  stockDetailRequest,
  stockEventsRequest,
  stockHisRequest,
  stockManagementRequest,
  stockNewsRequest,
  stockTradeRequest,
  transferDataRequest,
} from '../actions';

import {
  setCategory,
  setObjTrading,
  // saveCategoryRequest,
  setToast,
} from '../../../../containers/client/actions';

import { saveState } from '../../../../lib/storages';

import * as _ from 'lodash';
import {
  makeGetAllStock,
  makeGetAssociate,
  makeGetCategory,
  makeGetCollectionPrice,
  makeGetCompanyInfo,
  makeGetNewsDetail,
  makeGetStockCDKT,
  makeGetStockCST,
  makeGetStockDetail,
  makeGetStockEvents,
  makeGetStockHis,
  makeGetStockKQKD,
  makeGetStockManage,
  makeGetStockNews,
  makeGetToken,
  makeGetTransferData,
} from '../../../../lib/selector';
import StockSuggest from '../../../select/stockSuggest';

import { translate } from 'react-i18next';
import { BsCircleHalf } from 'react-icons/bs';
import TabECharts from './tabECharts';

// Hook
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

function StockDetailContent(props) {
  const [symbol, setSymbol] = React.useState('');
  const [tblActive, setTblActive] = React.useState(2);

  const prevObjTrading = usePrevious(props.objTrading);

  const dispatch = useDispatch();

  const { objTrading } = props;

  useEffect(() => {
    if (props.symbol) {
      dispatch(stockDetailRequest(props.symbol));
      dispatch(stockTradeRequest(props.symbol));
      dispatch(collectionPriceRequest(props.symbol));
      setSymbol(props.symbol);
    }
  }, [props.symbol]);

  useEffect(() => {
    if (objTrading && !_.isEqual(objTrading, prevObjTrading)) {
      dispatch(stockDetailRequest(objTrading.symbol));
      dispatch(stockTradeRequest(objTrading.symbol));
      dispatch(collectionPriceRequest(objTrading.symbol));
      setSymbol(objTrading.symbol);
    }
  }, [objTrading]);

  const _setKey = (key) => {
    console.log(key);
    switch (key) {
      case 'finance':
        _handleLoadFinance();
        break;

      case 'history':
        _handleLoadStockHis();
        break;

      case 'news':
        _handleLoadStockNews();
        _handleLoadEvents();
        break;

      case 'profile':
        _handleLoadProfile();
        break;

      case 'transferData':
        _handleLoadTransferData();
        break;

      default:
        break;
    }
  };

  const _handleLoadEvents = (paramsEvents) => {
    if (!paramsEvents) {
      var dt = new Date();
      const _toDate = new Date(new Date(dt).setMonth(dt.getMonth() + 6));
      const _fromDate = new Date(new Date(dt).setMonth(dt.getMonth() - 6));
      const _toYear = _toDate.getFullYear();
      const _toMonth = _toDate.getMonth();
      const _fromYear = _fromDate.getFullYear();
      const _fromMonth = _fromDate.getMonth();

      const firstDay = new Date(_fromYear, _fromMonth, 1);
      const lastDay = new Date(
        _toYear,
        _toMonth,
        daysInMonth(_toMonth, _toYear)
      );

      paramsEvents =
        'symbol=' +
        props.symbol +
        '&from=' +
        formatDate(firstDay, '-') +
        '&to=' +
        formatDate(lastDay, '-');
    }
    console.log(paramsEvents);
    dispatch(stockEventsRequest(paramsEvents));
  };

  const _handleLoadProfile = () => {
    dispatch(stockManagementRequest(symbol));
    dispatch(companyInfoRequest(symbol));
    dispatch(associateRequest(symbol));
  };

  const _handleLoadStockNews = () => {
    dispatch(stockNewsRequest(symbol));
  };

  const _handleLoadNewsDetail = (id) => {
    dispatch(newsDetailRequest(id));
  };

  const _handleLoadFinance = (termType = 2) => {
    const paramsCSTC =
      'symbol=' + symbol + '&type=CSTC&termtype=' + termType + '&from=1&to=4';
    dispatch(cstRequest(paramsCSTC));

    const paramsKQKD =
      'symbol=' + symbol + '&type=KQKD&termtype=' + termType + '&from=1&to=4';
    dispatch(kqkdRequest(paramsKQKD));

    const paramsCDKT =
      'symbol=' + symbol + '&type=CDKT&termtype=' + termType + '&from=1&to=4';
    dispatch(cdktRequest(paramsCDKT));
  };

  const _handleLoadStockHis = (type = '1m', page = 1, pageSize = 1000) => {
    let _type = 30;
    switch (type) {
      case '1w':
        _type = 7;
        break;
      case '1m':
        _type = 30;
        break;
      case '3m':
        _type = 90;
        break;
      case '6m':
        _type = 180;
        break;
      case '1y':
        _type = 365;
        break;

      default:
        break;
    }

    const paramsHis = `${symbol},${_type},1,1000`;
    dispatch(stockHisRequest(paramsHis));
  };

  const _handleLoadTransferData = () => {
    const dt = new Date();
    const _fromDate = new Date(new Date(dt).setMonth(dt.getMonth() - 6));

    const paramsHis =
      'symbol=' +
      symbol +
      '&from=' +
      formatDate(_fromDate, '-') +
      '&to=' +
      formatDate(dt, '-');
    dispatch(transferDataRequest(paramsHis));
  };

  const _handleAddStock = (_symbol) => {
    console.log(_symbol);
    if (_symbol) {
      dispatch(stockDetailRequest(_symbol));
      dispatch(stockTradeRequest(_symbol));
      setSymbol(_symbol);
      if (objTrading && objTrading.symbol !== _symbol) {
        const _params = Object.assign({}, objTrading);
        _params.symbol = _symbol;
        dispatch(setObjTrading(_params));
      }
    }
  };

  const _handleAddStockCategory = (categoryId) => {
    if (!symbol || !categoryId) return;

    let { category } = props;

    let isUpdate = false;

    category.forEach((element) => {
      if (element.id === categoryId) {
        if (element.value.indexOf(symbol) > -1) {
          const toastMsg = {
            id: Math.random(),
            msg: 'Chứng khoán đã ở trong list',
            title: 'Thông báo',
          };
          dispatch(setToast(toastMsg));
        } else {
          element.value.push(symbol);
          isUpdate = true;
        }
      }
    });

    if (isUpdate) {
      // save to action
      dispatch(setCategory(category));
      saveState('category', category);

      const toastMsg = {
        id: Math.random(),
        msg: 'Thêm mã thành công',
        title: 'Thông báo',
      };
      dispatch(setToast(toastMsg));
    }
  };

  const {
    stockDetail,
    cst,
    kqkd,
    cdkt,
    stockHis,
    transferData,
    stockNews,
    newsDetail,
    stockEvents,
    stockManage,
    companyInfo,
    associate,
    collectionPrice,
    allStock,
    category,
    className,
    t,
  } = props;

  const totalBV =
    stockDetail &&
    StringToInt(stockDetail.bV1) +
      StringToInt(stockDetail.bV2) +
      StringToInt(stockDetail.bV3);
  const totalOV =
    stockDetail &&
    StringToInt(stockDetail.oV1) +
      StringToInt(stockDetail.oV2) +
      StringToInt(stockDetail.oV3);

  const perBV1 =
    stockDetail && ~~((StringToInt(stockDetail.bV1) * 100) / totalBV);
  const perBV2 =
    stockDetail && ~~((StringToInt(stockDetail.bV2) * 100) / totalBV);
  const perBV3 =
    stockDetail && ~~((StringToInt(stockDetail.bV3) * 100) / totalBV);

  const perOV1 =
    stockDetail && ~~((StringToInt(stockDetail.oV1) * 100) / totalOV);
  const perOV2 =
    stockDetail && ~~((StringToInt(stockDetail.oV2) * 100) / totalOV);
  const perOV3 =
    stockDetail && ~~((StringToInt(stockDetail.oV3) * 100) / totalOV);

  const perBV =
    totalBV + totalOV === 0
      ? 50
      : stockDetail && ~~((totalBV * 100) / (totalBV + totalOV));

  const sym = _.find(allStock, (o) => o.stock_code === symbol);

  const _watchList = _.filter(category, (o) => o && o.type === 'watchlist');

  // console.log(stockDetail);

  const _cl =
    stockDetail &&
    colorFix(
      stockDetail.lastPrice,
      stockDetail.r,
      stockDetail.c,
      stockDetail.f,
      stockDetail.r
    );

  return (
    <div className={className} style={{ overflowY: 'hidden' }}>
      <div className="col-8 d-flex flex-column pt-2 pb-3">
        <div className="d-flex">
          <div className="position-relative detail-search">
            <StockSuggest
              dataSuggest={allStock}
              addStock={_handleAddStock}
              classname={'detail-search form-control fz-14 text-uppercase'}
              placeholder={t('txt-search')}
            />
            <img src={icMagnifier} className="form-search-img" />
          </div>
          <Dropdown className="picker-detail ml-2 mr-auto">
            <Dropdown.Toggle variant="secondary">
              {`${t('txt-add-to')}...`}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {_watchList &&
                !!_watchList.length &&
                _watchList.map((item) => (
                  <Dropdown.Item
                    key={item.id}
                    onClick={() => _handleAddStockCategory(item.id)}
                  >
                    {item.name}
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
          {companyInfo && companyInfo.IsMargin && (
            <span className="fz-16 title-unread">
              <BsCircleHalf
                className="pr-1"
                style={{
                  transform: 'rotate(58deg)',
                }}
              />
              {/* {'50%'} */}
            </span>
          )}
        </div>
        <div className="d-flex mt-1 bb-1 bt-1">
          <div className="d-flex align-items-center">
            {companyInfo && companyInfo.Image && (
              <img
                style={{
                  height: 'auto',
                  width: 'auto',
                  maxWidth: '125px',
                  maxHeight: '50px',
                }}
                src={`data:image/png;base64, ${companyInfo.Image}`}
                alt={companyInfo.FullName}
              />
            )}
          </div>
          <div className="d-flex flex-column ml-2 mr-auto">
            <div className="d-inline-flex align-items-center">
              <span
                className="font-weight-bold pr-1"
                style={{ fontSize: '24px', lineHeight: '1.3' }}
              >
                {symbol}
              </span>
              <span className="mc title-time fz-12 text-center ml-2">
                {sym &&
                  (sym.post_to === 'STO'
                    ? 'HOSE'
                    : sym.post_to === 'STX'
                    ? 'HNX'
                    : sym.post_to === 'UPX'
                    ? 'UPCOM'
                    : sym.post_to)}
              </span>
            </div>
            <div className="title-read fz-14 nowrap">{sym && sym.name_vn}</div>
          </div>
          <table className="table table-no-bordered w_150 br-1 bl-1 ml-2">
            <tbody>
              <tr>
                <td
                  style={{ height: '37px' }}
                  className={'fz-20 font-weight-bold ' + _cl}
                >
                  {stockDetail && numberFormat(stockDetail.lastPrice, 2)}
                </td>
                <td className={'fz-12 text-right ' + _cl}>
                  {stockDetail &&
                    `${numberFormat(
                      stockDetail.change,
                      2,
                      '-'
                    )} (${numberFormat(stockDetail.changePc, 2, '-')})`}
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="text-center">
                  Khối lượng:
                  <span className="font-weight-bold ml-1">
                    {stockDetail && formatVolume10(stockDetail.lot)}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <table className="table table-no-bordered w_125 br-1">
            <tbody>
              <tr className="bb-1">
                <td>Trần</td>
                <td className="c text-right font-weight-bold">
                  {stockDetail && numberFormat(stockDetail.c, 2)}
                </td>
              </tr>
              <tr className="bb-1">
                <td>T.C</td>
                <td className="r text-right font-weight-bold">
                  {stockDetail && numberFormat(stockDetail.r, 2)}
                </td>
              </tr>
              <tr>
                <td>Sàn</td>
                <td className="f text-right font-weight-bold">
                  {stockDetail && numberFormat(stockDetail.f, 2)}
                </td>
              </tr>
            </tbody>
          </table>
          <table className="table table-no-bordered w_125 br-1">
            <tbody>
              <tr className="bb-1">
                <td>NN mua</td>
                <td className="text-right font-weight-bold">
                  {stockDetail && numberFormat(stockDetail.fBVol)}
                </td>
              </tr>
              <tr className="bb-1">
                <td>NN bán</td>
                <td className="text-right font-weight-bold">
                  {stockDetail && numberFormat(stockDetail.fSVolume)}
                </td>
              </tr>
              <tr>
                <td>Room NN</td>
                <td className="text-right font-weight-bold">
                  {stockDetail && numberFormat(stockDetail.fRoom)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Tabs
          defaultActiveKey="overview"
          className="mt-2"
          onSelect={(e) => _setKey(e)}
        >
          <Tab eventKey="overview" title={t('txt-label-overview')}>
            {symbol && <OverView symbol={symbol} stockDetail={stockDetail} />}
          </Tab>
          <Tab eventKey="history" title={t('txt-label-history-price')}>
            {symbol && (
              <History
                symbol={symbol}
                stockHis={stockHis}
                loadStockHis={_handleLoadStockHis}
              />
            )}
          </Tab>
          <Tab eventKey="finance" title={t('txt-label-finance')}>
            {symbol && (
              <Finance
                symbol={symbol}
                cst={cst}
                kqkd={kqkd}
                cdkt={cdkt}
                loadFinance={_handleLoadFinance}
              />
            )}
          </Tab>
          <Tab eventKey="profile" title={t('txt-label-documents')}>
            {symbol && (
              <Profile
                symbol={symbol}
                stockManage={stockManage}
                // companyInfo={companyInfo}
                associate={associate}
                loadProfile={_handleLoadProfile}
              />
            )}
          </Tab>
          {/* <Tab eventKey="events" title={t('txt-label-events')}>
            {symbol && (
              <Events
                symbol={symbol}
                stockEvents={stockEvents}
                loadEvents={_handleLoadEvents}
              />
            )}
          </Tab> */}
          <Tab eventKey="news" title={t('txt-label-news')}>
            {symbol && (
              <News
                symbol={symbol}
                stockNews={stockNews}
                stockEvents={stockEvents}
                newsDetail={newsDetail}
                loadNews={_handleLoadStockNews}
                loadEvents={_handleLoadEvents}
                loadNewsDetail={_handleLoadNewsDetail}
                companyInfo={companyInfo}
              />
            )}
          </Tab>
          <Tab eventKey="transferData" title="Giao dịch nội bộ">
            {symbol && (
              <TransferData
                symbol={symbol}
                transferData={transferData}
                loadTransferData={_handleLoadTransferData}
              />
            )}
          </Tab>
        </Tabs>
      </div>
      <div
        className="col-4 p-2 position-relative d-flex flex-column"
        style={{ backgroundColor: '#f2f4f6' }}
      >
        <div className="d-flex justify-content-end align-items-center">
          {!props.isFullTrading && (
            <Fragment>
              <FaWindowMinimize
                className="content-read fz-12 mr-2"
                onClick={() => props.handleMinimize(symbol)}
              />
            </Fragment>
          )}
          <FaTimes onClick={props.handleCloseModal} />
        </div>
        <Card className="mt-2">
          <Card.Header className="d-flex">
            <span className="fz-14 content-read font-weight-bold mr-auto">
              {t('txt-label-details')}
            </span>
            <span className="fz-12 title-time">{`${t('txt-update')}: ${
              addZero(new Date().getHours()) +
              ':' +
              addZero(new Date().getMinutes())
            }`}</span>
          </Card.Header>
          <Card.Body className="p-0">
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th style={{ height: '20px' }}>
                    <span
                      className="position-absolute"
                      style={{ left: '5px', top: '4px' }}
                    >
                      Khối lượng
                    </span>
                    <span
                      className="position-absolute font-weight-bold i"
                      style={{ right: '5px', top: '4px' }}
                    >
                      MUA
                    </span>
                  </th>
                  <th>
                    <span
                      className="position-absolute font-weight-bold d"
                      style={{ left: '5px', top: '4px' }}
                    >
                      BÁN
                    </span>
                    <span
                      className="position-absolute"
                      style={{ right: '5px', top: '4px' }}
                    >
                      Khối lượng
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={2} className="position-relative progress-total">
                    <ProgressBar variant="success" now={perBV} />
                    <span className="per-vol-buy">
                      {stockDetail && formatVolume10(totalBV)}
                    </span>
                    <span className="per-vol-sell">
                      {stockDetail && formatVolume10(totalOV)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="position-relative rtl">
                    <span className="title-row">1</span>
                    <ProgressBar variant="info" now={perBV1} />
                    <span className="per-vol">
                      {stockDetail && formatVolume10(stockDetail.bV1)}
                    </span>
                    <span className="per-price">
                      {stockDetail && stockDetail.bP1}
                    </span>
                  </td>
                  <td className="position-relative">
                    <span className="title-row">1</span>
                    <ProgressBar variant="danger" now={perOV1} />
                    <span className="per-vol">
                      {stockDetail && formatVolume10(stockDetail.oV1)}
                    </span>
                    <span className="per-price" style={{ left: '5px' }}>
                      {stockDetail && stockDetail.oP1}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="position-relative rtl">
                    <span className="title-row">2</span>
                    <ProgressBar variant="info" now={perBV2} />
                    <span className="per-vol">
                      {stockDetail && formatVolume10(stockDetail.bV2)}
                    </span>
                    <span className="per-price">
                      {stockDetail && stockDetail.bP2}
                    </span>
                  </td>
                  <td className="position-relative">
                    <span className="title-row">2</span>
                    <span className="per-price" style={{ left: '5px' }}>
                      {stockDetail && stockDetail.oP2}
                    </span>
                    <ProgressBar variant="danger" now={perOV2} />
                    <span className="per-vol">
                      {stockDetail && formatVolume10(stockDetail.oV2)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="position-relative rtl">
                    <span className="title-row">3</span>
                    <span className="per-price">
                      {stockDetail && stockDetail.bP3}
                    </span>
                    <ProgressBar variant="info" now={perBV3} />
                    <span className="per-vol">
                      {stockDetail && formatVolume10(stockDetail.bV3)}
                    </span>
                  </td>
                  <td className="position-relative">
                    <span className="title-row">3</span>
                    <span className="per-price" style={{ left: '5px' }}>
                      {stockDetail && stockDetail.oP3}
                    </span>
                    <ProgressBar variant="danger" now={perOV3} />
                    <span className="per-vol">
                      {stockDetail && formatVolume10(stockDetail.oV3)}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </Card.Body>
        </Card>
        <Card className="mt-2">
          <Card.Header className="d-flex bg-white p-0">
            <ButtonGroup aria-label="Basic example" className="w-100">
              <Button
                variant="secondary"
                onClick={() => setTblActive(2)}
                className={
                  'text-uppercase ' + (tblActive === 2 ? 'active' : '')
                }
              >
                {t('txt-price')}
              </Button>
              <Button
                variant="secondary"
                onClick={() => setTblActive(1)}
                className={
                  'text-uppercase ' + (tblActive === 1 ? 'active' : '')
                }
              >
                {t('txt-match')}
              </Button>
            </ButtonGroup>
            {/* <span className="fz-14 mx-auto font-weight-bold">
              {t('txt-match')}
            </span> */}
          </Card.Header>
          <Card.Body className="p-0">
            {tblActive === 1 && <BuocGia />}
            {tblActive === 2 && (
              <TabECharts collectionPrice={collectionPrice} />
            )}
            {/* <BuocGia /> */}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

const makeMapStateToProps = () => {
  const getStockDetail = makeGetStockDetail();
  const getStockCst = makeGetStockCST();
  const getStockKQKD = makeGetStockKQKD();
  const getStockCDKT = makeGetStockCDKT();
  const getStockHis = makeGetStockHis();
  const getTransferData = makeGetTransferData();
  const getStockNews = makeGetStockNews();
  const getNewsDetail = makeGetNewsDetail();
  const getStockEvents = makeGetStockEvents();
  const getStockManage = makeGetStockManage();
  const getCompanyInfo = makeGetCompanyInfo();
  const getAssociate = makeGetAssociate();
  const getCollectionPrice = makeGetCollectionPrice();

  const getAllStock = makeGetAllStock();
  const getCategory = makeGetCategory();
  const getToken = makeGetToken();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      stockDetail: getStockDetail(state),
      cst: getStockCst(state),
      kqkd: getStockKQKD(state),
      cdkt: getStockCDKT(state),
      stockHis: getStockHis(state),
      transferData: getTransferData(state),
      stockNews: getStockNews(state),
      newsDetail: getNewsDetail(state),
      stockEvents: getStockEvents(state),
      stockManage: getStockManage(state),
      companyInfo: getCompanyInfo(state),
      associate: getAssociate(state),
      collectionPrice: getCollectionPrice(state),
      allStock: getAllStock(state),
      category: getCategory(state),
      objTrading: state.client.objTrading,
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(StockDetailContent)
);
